<template>
    <span :class="{ 'text-danger font-weight-bold': isExpiresSoon }">
        {{ status }}
    </span>
</template>

<script>
import { REVIEW_STATUS_EXPIRES_SOON, REVIEW_STATUS_MAPPING } from '../../../../../constants';
export default {
    data() {
        return {
            review: null,
        };
    },
    created() {
        this.review = this.params.data;
    },
    computed: {
        status() {
            return REVIEW_STATUS_MAPPING[this.review.review_status];
        },
        isExpiresSoon() {
            this.review.review_status === REVIEW_STATUS_EXPIRES_SOON;
        },
    },
};
</script>
